import axiosClient from "../api/axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const dashboardApi = {
  getDashboards: () => {
    const url = "dashboard";
    return axiosClient.get(url);
  },
};

export default dashboardApi;
